import pdfMake, { userMark, setMyConfig, makeTableContent } from '../utils/pdf';

function pdfPrivadoItinerario (pContent) {
  const columns = [
    {
      key: 'nro',
      label: 'Nro.',
      width: 'auto'
    },
    'fecha:w45',
    'servicio:w*',
    'proveedor:w*',
    'hotel:w*',
    {
      key: 'vueloTourTren',
      label: 'Vuelo / Tour / Tren',
      width: 60
    },
    {
      key: 'guia',
      label: 'Guía',
      width: '*'
    },
    {
      key: 'servicioSigla',
      label: 'Tipo',
      width: 'auto'
    },
    'restaurante:wauto',
    'observaciones:w*',
  ]

  const table = makeTableContent([...pContent.itinerario], columns);

  pdfMake.createPdf({
    info: {
      title: `Reporte Itinerario`
    },
    content: [
      {
        text: 'Reporte Itinerario',
        style: 'header'
      },
      {
        columns: [
          {
            text: `Código: ${pContent.registro.codigo}`,
            width: 'auto'
          },
          {
            text: `Doc. Venta: ${pContent.registro.docVenta}`,
            width: 'auto'
          },
          {
            text: `Nro. Doc. Venta: ${pContent.registro.nroDocVenta || ''}`,
            width: 'auto'
          },
          {
            text: `Fecha Llegada: ${pContent.registro.fechaLlegada}`,
            width: 'auto'
          },
          {
            text: `Fecha Salida: ${pContent.registro.fechaSalida}`,
            width: 'auto'
          },
          {
            text: `Agencia: ${pContent.registro.agencia}`,
            width: '*'
          },
        ],
        margin: [0,0,0,5]
      },
      {
        columns: [
          {
            text: `Idioma: ${pContent.registro.idioma}`,
            width: 'auto'
          },
          {
            text: `PAX: ${pContent.registro.nroAdultos}`,
            width: 'auto'
          },
          {
            text: `CHD: ${pContent.registro.nroNinos || ''}`,
            width: 'auto'
          },
          {
            text: `Pasajero: ${pContent.registro.pasajero}`,
            width: 'auto'
          },
        ],
        margin: [0,0,0,5]
      },
      table,
      ...userMark(pContent.userMark, pContent.dateMark)
    ],
    ...setMyConfig()
  }).print();

  
}

export default pdfPrivadoItinerario;